import { linearProgressClasses, styled } from '@mui/material';
import { React } from 'Imports';
import { LinearProgress } from 'MaterialUIComponents';
import { isEncompass } from '$Utilities/integrationPlatform';

const VPLinearProgress = styled(LinearProgress)(() => ({
    height: 8,
    borderRadius: 4,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: isEncompass ? '#D3D8DF' : '#E0E5EE',
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 4,
        backgroundColor: isEncompass ? '#0D7AC5' : '#0078D3',
    },
}));

const styles = require('./ProgressBar.scss') as {
    geotab: string;
    encompass: string;
    progressBarAndTitleWrapper: string;
    title: string;
    progressBarContainer: string;
    progressBar: string;
    progressBarValue: string;
};

interface ProgressBarProps {
    loadingProgress: number | null;
}

const ProgressBar = ({ loadingProgress }: ProgressBarProps) => {
    const mainClass = isEncompass ? styles.encompass : styles.geotab;
    return (
        <div className={mainClass}>
            <div className={styles.progressBarAndTitleWrapper}>
                <div className={styles.title}>Footage loading...</div>
                {loadingProgress !== null && (
                    <div className={styles.progressBarContainer}>
                        <VPLinearProgress variant="determinate" value={loadingProgress} className={styles.progressBar} />
                        <div className={styles.progressBarValue}>{loadingProgress}%</div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProgressBar;
